import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

const CreateGroup = (param: any) =>
    request({
        url: ApiURL.Command.createScheduleGroup,
        method: RequestType.POST,
        data: param,
    });

const UpdateGroup = (param: any) =>
    request({
        url: ApiURL.Command.updateScheduleGroup,
        method: RequestType.PUT,
        data: param,
    });

const CreateGroupUser = (param: any) =>
    request({
        url: ApiURL.Command.createGroupUser,
        method: RequestType.POST,
        data: param,
    });

const DeleteGroupUser = (param: any) =>
    request({
        url: ApiURL.Command.deleteGroupUser,
        method: RequestType.DELETE,
        data: param,
    });

const ScheduleGroupCommand = {
    UpdateGroup,
    CreateGroup,
    CreateGroupUser,
    DeleteGroupUser,
};

export default ScheduleGroupCommand;
